export default __webpack_public_path__ + "static/media/training-illustration3.fb187cf4.png";